module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selling-large-c799dad2ff2ed33a4409f9415a0a8d56.svg";